import React from 'react';
import { useCookies } from 'react-cookie';
import Content from '../../../../components/Section/Content';
import Box from '../../../../components/Section/Box';
import Icon from '../../../../components/Section/Icon';
import svg from '../../../../static/img/icon-open-menu.svg';
import { SignatureContent } from './styles';
import environmentConfigs from '../../../../config/environment-configs';
import { useAuth } from '../../../../hooks/useAuth';
import { Actions, Categories, Labels } from '../../../../types/gtm';
import Action from '../../../../components/Section/Action';

const BoxSignatures = () => {
  const [cookies] = useCookies();
  const { user } = useAuth();
  const title = 'Assinaturas';
  const describeTitle =
    'Veja pagamentos, altere planos, consulte solicitações, renovações e cancelamento';

  const origemId = cookies.f_origemId || '2001';
  const redirectUrl = `${environmentConfigs.ACCOUNT_MANAGEMENT_URL}/`;

  const handleRedirect = environmentConfigs.ASSIGNATURE_URL.replace(
    ':origemId',
    origemId,
  )
    .replace(':url', redirectUrl)
    .replace(':glbid', user?.globoId);

  const sendEventGA = () => {
    window.dataLayer.push({
      event: 'customEventUserInteraction',
      event_category: Categories.Home,
      event_action: Actions.ClickEditAssignatures,
      event_label: Labels.Home,
      bd_suser_code: user?.globoId,
    });
  };

  return (
    <Box title={title} describeTitle={describeTitle}>
      <SignatureContent>
        <Content>
          <Action onClick={sendEventGA} href={handleRedirect} theme="link">
            <p>Gerenciar assinaturas</p>
            <Icon svg={svg} alt="icon-open-menu" />
          </Action>
        </Content>
      </SignatureContent>
    </Box>
  );
};

export default BoxSignatures;
